Table = {

    init: function(){
        if(typeof Editor != "undefined") return;

        var tables = $('.row[data-component="table"]');
        
        if(tables.length < 1) return;

        tables.each(function(i, table) {
            var headers_length = $('.content > .tabulka.responsive > .table-headers > .cell', table).length;
            var cells = $('.content > .tabulka.responsive > div[class="row"] > .cell', table);
            cells.each(function(i, cell) {
                if( (i%headers_length) === 0 ) return;
                $(cell).prepend('<span>' + $('.table-headers > .cell:nth-child(' + ((i % headers_length) + 1) + ')', $(cell).parentsUntil('.content')).text() + '</span>');
            })
        })
    }
}